class JKWishlist {
  items = [];
  localKey = 'wlst-ids';

  constructor(signedIn) {
    this.signedIn = signedIn;
    this.#loadItems();
  }

  has(key) {
    return this.items.includes(key);
  }
  add(key) {
    return this.toggle(key, true);
  }
  remove(key) {
    return this.toggle(key, false);
  }
  async toggle(key, add) {
    const itemIdx = this.items.indexOf(key);
    add = add !== undefined ? add : itemIdx < 0;
    if (add) {
      if (itemIdx > -1) return true;
      this.items.push(key);
    } else {
      if (itemIdx < 0) return true;
      this.items.splice(itemIdx, 1);
    }
    if (!this.signedIn) {
      this.#storeItem(this.localKey, this.items);
    } else {
      const updated = await this.#update(this.items);
      if (!updated) {
        const oldIdx = this.items.indexOf(key);
        if (add && oldIdx > -1) {
          this.items.splice(oldIdx, 1);
        } else if (!add && oldIdx < 0) {
          this.items.push(key);
        }
        return false;
      }
    }
    return true;
  }
  async clear(items) {
    const filtered = items ? [...this.items].filter((key) => !items.includes(key)) : [];
    const result = this.signedIn ? await this.#update(filtered) : true;
    if (result) {
      this.items = filtered;
      if (filtered.length === 0) {
        localStorage.removeItem(this.localKey);
      } else if (!this.signedIn) {
        this.#storeItem(this.localKey, filtered);
      }
    }
    return result;
  }

  #loadItems() {
    const local = this.#getStoredItem(this.localKey) || [];
    if (this.signedIn) {
      const savedText = document.querySelector('#WishlistItems')?.innerHTML;
      const saved = (!!savedText ? JSON.parse(savedText) : []).filter((item) => !item.endsWith(':'));
      if (local.length > 0) {
        local.forEach((i) => saved.includes(i) && saved.push(i));
        localStorage.removeItem(this.localKey);
        this.#update(saved);
      }
      this.items = saved;
    } else {
      this.items = local;
    }
  }

  async #update(items) {
    try {
      const response = await fetch(`${routes.app}/wishlist`, {
        method: 'PUT',
        body: JSON.stringify({ items }),
        headers: { 'content-type': 'application/json' },
      });
      if (response.status === 200) {
        !this.signedIn && this.#storeItem(this.localKey, items);
        return true;
      }
    } catch (err) {
      console.err(err);
    }
    return false;
  }

  #storeItem(key, value, maxAge = 90 * 24 * 60 * 60 * 1000) {
    const result = { data: value };
    if (!this.signedIn) result.expireTime = Date.now() + maxAge;
    localStorage.setItem(key, JSON.stringify(result));
  }

  #getStoredItem(key) {
    const result = JSON.parse(localStorage.getItem(key));
    if (result) {
      if (result.expireTime && result.expireTime <= Date.now()) {
        localStorage.removeItem(key);
        return null;
      }
      return result.data;
    }
    return null;
  }
}

class WishlistIcon extends HTMLElement {
  constructor() {
    super();
    window.jk = window.jk || {};
    window.jk.Wishlist = new JKWishlist(this.hasAttribute('data-signed-in'));
    document.dispatchEvent(new CustomEvent('wishlist:loaded'));
  }
}

customElements.define('wishlist-icon', WishlistIcon);

class WishlistToggle extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.$button = this.querySelector('button');
    this.$buttonText = this.$button.querySelector('span.text');
    const [product, variant] = this.dataset.key.split(':');
    this.$button.addEventListener('click', this.onClick);
    this.toggleChecked(window.jk.Wishlist.has(this.dataset.key));
  }

  disconnectedCallback() {
    this.$button.removeEventListener('click', this.onClick);
  }

  onClick() {
    this.$button.disabled = true;
    window.jk.Wishlist.toggle(this.dataset.key, !this.checked).then((success) => {
      if (!success) this.toggleChecked(!this.checked);
      this.$button.disabled = false;
    });
    this.toggleChecked(!this.checked);
  }

  setKey(key) {
    this.dataset.key = key;
    this.toggleChecked(window.jk.Wishlist.has(this.dataset.key));
  }

  toggleChecked(checked) {
    this.setAttribute('checked', checked);
    this.checked = checked;
    const label = checked ? 'Remove from wishlist' : 'Add to wishlist';
    this.$button.title = label;
    this.$button.ariaLabel = label;
    this.$buttonText && (this.$buttonText.innerHTML = label);
    if (checked) {
      this.$button.classList.add('fill');
    } else {
      this.$button.classList.remove('fill');
    }
  }
}

customElements.define('wishlist-toggle', WishlistToggle);
